export default "__VITE_ASSET__dd14fc69__"